<template>
  <div
    class="flex w-full flex-col items-center self-center sm:gap-24 gap-8 m-16 sm:m-0"
  >
    <p class="font-sans-bold font-bold self-start text-2xl">
      {{ $t('health_actions.scheduling.schedule_success_title') }}
    </p>
    <Body class="sm:font-bold text-lg self-start">
      {{
        $t('health_actions.scheduling.schedule_success_description', [
          formattedPhone,
        ])
      }}
    </Body>
    <img
      src="../../../../../assets/images/Schedule_Success.png"
      alt="Schedule Success"
      class="mx-auto mb-14 mt-8 sm:mt-0"
    />
    <HMButton class="self-center" @click="handleBack">{{
      $t('health_actions.scheduling.schedule_success_return_btn')
    }}</HMButton>
  </div>
</template>

<script>
import Body from '~/components/common/Typography/Body.vue'
import H3 from '~/components/common/Typography/H3.vue'
import screenSizeMixin from '~/components/mixins/screenSizeMixin'
import { mapActions } from 'vuex'
import { formatPhoneNumber } from '@platform-shared/utils/formatters.js'

export default {
  components: {
    H3,
    Body,
  },
  mixins: [screenSizeMixin],
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedPhone() {
      return this.phoneNumber ? formatPhoneNumber(this.phoneNumber) : 'N/A'
    },
  },
  methods: {
    ...mapActions('scheduling', ['resetState']),
    handleBack() {
      this.resetState()
      this.$router.back()
    },
  },
}
</script>
